import { createClient } from '@/shared/api';
import type { FacilityDetailQuery, FacilityDetailQueryVariables } from '@/shared/api';
import FACILITY_DETAIL_QUERY from '../queries/facilityDetail';

/**
 * Loads the detail view of a single facility. Runs the facility detail query for the id and returns the facility from the response without inspecting errors.
 *
 * @param id - Identifier of the facility to load.
 * @returns A promise resolving to the facility detail payload.
 */
const fetchFacilityDetail = async (id: any) => {
  const client = createClient();
  const result = await client.query<FacilityDetailQuery, FacilityDetailQueryVariables>({
    query: FACILITY_DETAIL_QUERY,
    variables: {
      id,
    },
  });
  const { data } = result;
  const { facility } = data;
  return facility;
};

export default fetchFacilityDetail;
